// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for AdministrationMethod Model Structure
 * @see #/components/schemas/AdministrationMethod - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface AdministrationMethod {
    /**
     * The code-value from a code system (LOINC, SNOMED, Custom).
     *
     */
    code: string;
    /**
     * Readable name for the code.
     *
     */
    display_name: string;
    /**
     * The mapping to known FHIR routes, represented by their code, see https://www.hl7.org/fhir/valueset-route-codes.html
     *
     */
    route_code: string;
    /**
     * The text representation of the mapped route.
     *
     */
    route_display_name: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for AdministrationMethod
 */
export namespace AdministrationMethod {
    /**
     * AdministrationMethod Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The code-value from a code system (LOINC, SNOMED, Custom).
         * @type string (`dataFormat` is missing)
         */
        code: string;
        /**
         * Readable name for the code.
         * @type string (`dataFormat` is missing)
         */
        displayName: string;
        /**
         * The mapping to known FHIR routes, represented by their code, see https://www.hl7.org/fhir/valueset-route-codes.html
         * @type string (`dataFormat` is missing)
         */
        routeCode: string;
        /**
         * The text representation of the mapped route.
         * @type string (`dataFormat` is missing)
         */
        routeDisplayName: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * AdministrationMethod DTO
     * Transforms AdministrationMethod model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend AdministrationMethod model */
        static toModel(obj: AdministrationMethod): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend AdministrationMethod model */
        static toApi(obj: Model): AdministrationMethod {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as AdministrationMethod;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
